import { Controller } from '@hotwired/stimulus';
import '../src/jquery';
import select2 from 'select2/dist/js/select2.full';
select2($);

// Connects to data-controller="select2"
// Used in: form partial 'dropdown', districts custom form, students custom form
// Used for: initating select 2 gem for dropdowns with search
// Explanation: due to esbuild file prioritisation jquery, which is a required for select 2, needs to be imported from a src file above select 2 import
export default class extends Controller {
  static targets = ['source'];
  connect() {
    // on connect, find and initiate select 2 elements
    console.log('Select2 controller connected');
    const select2El = $('.select2');
    // console.log(select2El);
    select2El.select2();
  }
  disconnect() {
    console.log('Select2 controller disconnected');
    const select2El = $('.select2');
    if (select2El.data('select2')) {
      select2El.select2('destroy');
    }
  }
}
